import styled from 'styled-components'

import { maxmedia } from '../../styles/media-queries'
import { inputgray } from '../../styles/colors'

export const TableHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  ${maxmedia.large`
    display: none;
  `}
`

export const HeaderItem = styled.div`
  width: calc(100% / 4 - 80px);
  text-transform: uppercase;
  font-size: 14px;
  color: ${inputgray};
  font-weight: 500;
  letter-spacing: 1px;
  margin-bottom: 1rem;

  &:first-child {
    padding-left: 1.5rem;
  }
`


// WEBPACK FOOTER //
// ./src/components/DocumentTable/styles.js